import flipYAxis from './helpers/flipYAxis';

class Snapshot {
  constructor(textureManager) {
    this.textureManager = textureManager;
  }

  make(textureName) {
    this.createCanvas();

    const saveContext = this.canvas.getContext('2d');

    const savePixels = this.textureManager.readPixels(textureName);

    const imageData = flipYAxis(saveContext, savePixels, this.textureManager.width, this.textureManager.height);

    saveContext.putImageData(imageData, 0, 0);

    this.save();

    this.removeCanvas();
  }

  createCanvas() {
    this.canvas = document.createElement('canvas');

    this.canvas.width = this.textureManager.width;
    this.canvas.height = this.textureManager.height;
    this.canvas.style.position = 'fixed';
    this.canvas.style.top = '-999999px';
    this.canvas.style.left = '-999999px';
    this.canvas.style.pointerEvents = 'none';

    document.body.appendChild(this.canvas);
  }

  removeCanvas() {
    document.body.removeChild(this.canvas);
  }

  save() {
    const image = this.canvas.toDataURL('image/png', 1.0).replace('image/png', 'image/octet-stream');

    const link = document.createElement('a');
    link.download = 'my-image.png';
    link.href = image;
    link.style.display = 'none';
    link.click();
  }
}

export default Snapshot;
